module.exports = __webpack_public_path__ + "static/img/shiliu.7de62fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/shiliu.png
// module id = 3Dqp
// module chunks = 1